import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

import { Heading } from '@vfuk/core-heading/dist/styles/Heading.style'
import { spacing } from '@vfuk/core-mixins'

export const DesktopLinkListWrapper = styled.div(
  (): FlattenSimpleInterpolation => css`
    display: flex;
    flex-direction: column;
    ${spacing('margin-bottom', 8)};
    ${spacing('gap', 1)}

    ${Heading} {
      ${spacing('margin-bottom', 1)}
    }
  `,
)
